<template>
  <div class="order-purchased-box max-width-box">
    <div class="search-box" v-if="!orderInformationVisible">
      <div class="search-box-fliter-box">
        <div class="search-box-fliter">
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="orderPopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': orderStatusLabelList.length > 0 }"
              slot="reference"
            >
              Order Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': orderPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="orderStatusLabelList">
              <el-checkbox
                v-for="(item, index) in orderStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(1)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(1)"
                >Apply</el-button
              >
            </div>
          </el-popover>
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="refundPopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': refundStatusLabelList.length > 0 }"
              slot="reference"
            >
              Refund Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': refundPopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="refundStatusLabelList">
              <el-checkbox
                v-for="(item, index) in refundStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(2)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(2)"
                >Apply</el-button
              >
            </div>
          </el-popover>
        </div>
        <div class="search-box-reset-box">
          <el-button class="reset-bt" size="small" @click="resetFilter(1)"
            >Reset</el-button
          >
        </div>
      </div>

      <div class="search-box-li" v-if="showFilterLabels">
        <div
          class="filters-wrapper"
          v-for="(item, index) in orderStatusLabelList"
          :key="index"
        >
          {{ item }}
        </div>
        <div
          class="filters-wrapper"
          v-for="(item, index) in refundStatusLabelList"
          :key="'refund' + index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="myinfo-com-pur-content" v-if="!orderInformationVisible">
      <div class="list-head">
        <div class="flex_8">Order</div>
        <div class="flex_3">Price</div>
        <!-- <div class="flex_3">Status</div> -->
        <div class="flex" style="width: 200px">Progress</div>
        <div class="flex_4">Time</div>
        <div class="flex_3">Operation</div>
      </div>
      <div
        class="list-content"
        v-for="(item, index) in purchasedOrderList"
        :key="index"
      >
        <div class="flex_8 info-box">
          <img class="info-img" :src="item.covey_course.courseImg[0]" />
          <div style="width: 8px; height: 100%; display: inline-block"></div>
          <div class="info-detail">
            <div class="detail-title" :title="item.covey_course.courseName">
              {{ item.covey_course.courseName }}
            </div>
            <div
              class="detail-content"
              :title="item.covey_user ? item.covey_user.realname : ''"
            >
              Tutor: {{ item.covey_user ? item.covey_user.realname : "" }}
            </div>
            <i
              class="chat-icon el-icon-chat-dot-square"
              @click="contactPeople(item.teacherId)"
            ></i>
            <div class="id_time">
              <!-- <div class="detail-content">Course ID: {{item.covey_course.courseNo}}</div> -->
              <div class="detail-content">Order ID: {{ item.id }}</div>
            </div>
          </div>
        </div>

        <div class="flex_3">
          <div class="price-info-detail">
            <div class="price-item" :title="item.pay_price | formatMoneyNumber">
              <div class="price-t">Price:</div>
              <span class="price-v"
                >C$ {{ item.pay_price | formatMoneyNumber }}</span
              >
            </div>
            <div class="price-item" :title="item.pay_money | formatMoneyNumber">
              <div class="price-t">Fee:</div>
              <span class="price-v"
                >C$ {{ item.pay_money | formatMoneyNumber }}</span
              >
            </div>

            <div
              v-if="item.refund_status !== 0"
              class="price-item"
              :title="item.return_money | formatMoneyNumber"
            >
              <div class="price-t">Refund:</div>
              <span class="price-v"
                >C$ {{ item.return_money | formatMoneyNumber }}</span
              >
            </div>
          </div>
        </div>

        <div class="flex" style="width: 200px">
          <div class="price-info-detail">
            <div>
              <i
                style="margin-right: 8px"
                :class="orderStatusMap[item.order_status].icon"
                :style="{ color: orderStatusMap[item.order_status].color }"
              ></i>
              <span>{{ orderStatusMap[item.order_status].name }}</span>
            </div>
            <div v-if="item.refund_status !== 0">
              <i
                style="margin-right: 8px"
                :class="refund_status[item.refund_status].icon"
                :style="{ color: refund_status[item.refund_status].color }"
              ></i>
              <span>{{ refund_status[item.refund_status].name }}</span>
            </div>
            <el-progress
              color="#f3ac50"
              :stroke-width="26"
              :format="(p) => orderProgressFomat(p, item)"
              :text-inside="true"
              :percentage="
                parseFloat(
                  (
                    ((item.used_amounts + item.cancel_amounts) * 100) /
                    item.amounts
                  ).toFixed(2)
                )
              "
            ></el-progress>
          </div>
          <!-- 1.订单数量 amounts
                    2.使用数量 used_amounts
                    3.取消数量 cancel_amounts
                    4.进度条 值为 (使用数量+取消数量)/订单数量 -->
        </div>

        <div class="flex_4">
          <div class="price-info-detail">
            <div
              class="detail-content"
              :title="
                'Create time: ' +
                format(item.create_time, 'MM/DD/YYYY HH:mm:ss')
              "
            >
              <!-- <div>Create time:</div> -->
              <span class="ellipsis1">{{
                format(item.create_time, "MM/DD/YYYY HH:mm:ss")
              }}</span>
            </div>
            <div
              class="detail-content"
              :title="
                item.pay_time
                  ? 'Pay time: ' + format(item.pay_time, 'MM/DD/YYYY HH:mm:ss')
                  : ''
              "
            >
              <!-- <div>Pay time: </div> -->
              <span class="ellipsis1">{{
                item.pay_time
                  ? format(item.pay_time, "MM/DD/YYYY HH:mm:ss")
                  : ""
              }}</span>
            </div>
          </div>
        </div>
        <div class="flex_3 operation_events">
          <!-- <div><span @click="checkOrder(item)">Check order</span></div> -->

          <!-- <div><span class="cancel" @click="withdrawOrder(item)">申请退款</span></div> -->

          <div><span @click="checkOrder(item)">View order</span></div>
          <div>
            <span v-if="item.order_status === 1" @click="gotoPay(item)"
              >Pay</span
            >
          </div>
          <div>
            <span v-if="item.order_status === 1" @click="cancelClass(item)"
              >Cancel order</span
            >
          </div>

          <div>
            <span
              v-if="[2, 4].includes(item.order_status)"
              @click="withdrawOrder(item)"
              >Apply for refund</span
            >
          </div>
        </div>
      </div>
      <div v-if="purchasedOrderList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - purchasedOrderList.length"
          :key="index"
        ></div>
      </div>
    </div>
    <KtPag
      v-if="!orderInformationVisible"
      style="text-align: right"
      :pageCount="orderlistForm.count"
      :currentPage="orderlistForm.page"
      :limit="orderlistForm.limit"
      @onChange="onPurchasedListPageChange"
    ></KtPag>

    <div class="order-information" v-if="orderInformationVisible">
      <div class="item-title" style="margin-top: 0">Order information</div>
      <div class="item-content">
        <div class="item-content-left">
          <img
            :src="
              orderDetail.covey_course
                ? orderDetail.covey_course.courseImg[0]
                : ''
            "
          />
          <div class="order-info">
            <div>
              {{
                orderDetail.covey_course
                  ? orderDetail.covey_course.courseName
                  : ""
              }}
            </div>
            <div>
              Tutor:
              {{
                orderDetail.covey_course
                  ? orderDetail.covey_course.courseName
                  : ""
              }}
            </div>
            <!-- <div>Course ID: {{orderDetail.covey_course.courseNo}}</div> -->
            <div>Order ID: {{ orderDetail.id }}</div>
            <div>
              {{
                format(orderDetail.create_time, "ddd, MMM. Do, YYYY hh:mm A")
              }}
            </div>
          </div>
        </div>
        <div class="item-content-right">
          <div>C${{ orderDetail.pay_money | formatMoneyNumber }}</div>
          <div>Order Amounts: {{ orderDetail.amounts }}</div>
          <div>
            Pay Price: C$ {{ orderDetail.price | formatMoneyNumber }} / 1 lesson
          </div>
        </div>
      </div>
      <div class="item-title">
        <span>
          Course List
          <i
            style="font-size: 14px"
            class="el-icon-refresh goback"
            @click="getChildOrderList(1)"
          ></i>
        </span>

        <el-button
          type="text"
          class="goback"
          icon="el-icon-back"
          @click="goBack"
          >Back</el-button
        >
      </div>
      <div class="search-box">
        <div class="search-box-fliter-box">
          <div class="search-box-fliter">
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="childOrderPopoverShow"
              popper-class="pc-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{
                  'select-filter': childOrderStatuslabelList.length > 0,
                }"
                slot="reference"
              >
                Order Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[{ 'submenu-icon-arrow': childOrderPopoverShow }]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="childOrderStatuslabelList">
                <el-checkbox
                  v-for="(item, index) in childOrderStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(3)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(3)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="commentStatusPopoverShow"
              popper-class="pc-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{ 'select-filter': commentStatusLabelList.length > 0 }"
                slot="reference"
              >
                Comment Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[
                      { 'submenu-icon-arrow': commentStatusPopoverShow },
                    ]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="commentStatusLabelList">
                <el-checkbox
                  v-for="(item, index) in commentStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(4)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(4)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
            <el-popover
              placement="bottom-start"
              width="220"
              trigger="click"
              v-model="complainStatusPopoverShow"
              popper-class="pc-filter-popover"
            >
              <div
                class="filter-btn-box"
                :class="{ 'select-filter': complainStatusLabelList.length > 0 }"
                slot="reference"
              >
                Complain Status<span class="arrow-box"
                  ><i
                    class="el-icon-arrow-down"
                    :class="[
                      { 'submenu-icon-arrow': complainStatusPopoverShow },
                    ]"
                  ></i
                ></span>
              </div>
              <el-checkbox-group v-model="complainStatusLabelList">
                <el-checkbox
                  v-for="(item, index) in complainStatusList"
                  :label="item.name"
                  :key="index"
                ></el-checkbox>
              </el-checkbox-group>
              <div class="popover-footer">
                <el-button
                  type="text"
                  size="small"
                  class="clear-bt"
                  @click="clearFilterLabel(5)"
                  >Clear All</el-button
                >
                <el-button
                  size="small"
                  class="apply-bt"
                  @click.stop="applyFilter(5)"
                  >Apply</el-button
                >
              </div>
            </el-popover>
          </div>
          <div class="search-box-reset-box">
            <el-button class="reset-bt" size="small" @click="resetFilter(2)"
              >Reset</el-button
            >
          </div>
        </div>

        <div class="search-box-li" v-if="showChildFilterLabels">
          <div
            class="filters-wrapper"
            v-for="(item, index) in childOrderStatuslabelList"
            :key="index"
          >
            {{ item }}
          </div>
          <div
            class="filters-wrapper"
            v-for="(item, index) in commentStatusLabelList"
            :key="'comment' + index"
          >
            {{ item }}
          </div>
          <div
            class="filters-wrapper"
            v-for="(item, index) in complainStatusLabelList"
            :key="'complain' + index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="order-course-list">
        <div class="list-head">
          <div class="flex_2">Session</div>
          <div class="flex_3">Time</div>
          <div class="flex_3">Room</div>
          <div class="flex_3">Status</div>
          <div class="flex_3">Comment</div>
          <div class="flex_3">Operation</div>
        </div>
        <div
          class="list-content"
          v-for="(item, index) of childOrderList"
          :key="index"
        >
          <div class="flex_2">{{ item.id }}</div>
          <div
            class="flex_3"
            :title="
              format(item.apdate, 'ddd, MMM. Do, YYYY') +
              ' ' +
              item.starttime +
              '-' +
              item.endtime
            "
          >
            {{
              format(item.apdate, "ddd, MMM. Do, YYYY") +
              " " +
              item.starttime +
              "-" +
              item.endtime
            }}
          </div>

          <div class="flex_3">
            <div>
              site:
              <a
                class="room_site"
                v-if="item.roomsite"
                :href="item.roomsite"
                target="_blank"
                >Go to the site</a
              >
            </div>
            <div>code: {{ item.roomcode }}</div>
          </div>

          <div class="flex_3">
            <span>
              <i
                style="margin-right: 8px"
                :class="childOrderStatusMap[item.status].icon"
                :style="{ color: childOrderStatusMap[item.status].color }"
              ></i>
              <span>{{ childOrderStatusMap[item.status].name }}</span>
            </span>
            <div
              v-if="
                item.complainstatus !== 0 && [1, 3, 4, 5].includes(item.status)
              "
            >
              {{ complainstatusMap[item.complainstatus] }}
            </div>
            <el-tooltip
              v-if="
                [1, 3, 4].includes(parseInt(item.status)) &&
                item.complainstatus === 0
              "
              content="If you have any objection to this order, click to case"
              placement="top"
              effect="light"
            >
              <div slot="content">
                If you have any objection to this order,<a
                  href="javascript:void(0)"
                  @click="gotoLessonappeal(item)"
                  >click</a
                >&nbsp;to case
              </div>
              <i class="oprate-icon el-icon-question"></i>
            </el-tooltip>
          </div>

          <div class="flex_3">
            <div :style="{ color: commentstatusMap[item.commentstatus].color }">
              <i
                style="margin-right: 8px"
                :class="commentstatusMap[item.commentstatus].icon"
              ></i>
              <span>{{ commentstatusMap[item.commentstatus].name }}</span>
            </div>
          </div>

          <div class="flex_3 operation_events">
            <span
              v-if="item.status === 5 && item.commentstatus === 0"
              @click="openEvaluateDialog(item)"
              >To evaluate</span
            >
            <span
              v-if="item.status === 5 && item.commentstatus === 1"
              @click="openReviewdialog(item)"
              >Check Reviews</span
            >
            <span v-if="item.status === 1" @click="changeTime(item)"
              >Rescheduling request</span
            >
            <span v-if="item.status === 4" @click="confirmClass(item)"
              >Confirm class</span
            >

            <el-badge
              v-if="
                item.complainstatus !== 0 && [1, 3, 4, 5].includes(item.status)
              "
              is-dot
            >
              <span @click="viewappeal(item)">View appeal</span>
            </el-badge>

            <div v-if="item.changeapply === 1 && parseInt(item.status) === 1">
              <el-popover placement="left" v-if="userInfo.id !== item.applyId">
                <div style="padding: 12px; font-size: 14px">
                  <div style="font-size: 20px; margin-bottom: 12px">Check</div>
                  <div>
                    <div style="margin-top: 12px">
                      Original time:<span>{{
                        item.apdate + " " + item.starttime + "-" + item.endtime
                      }}</span>
                    </div>
                    <div style="margin-top: 12px">
                      Time submitted:
                      <span>{{ updateCourseTimeForm.targetTime }}</span>
                    </div>
                    <div style="margin-top: 12px">Feedbacks</div>
                    <el-radio
                      style="margin-top: 12px"
                      v-model="updateCourseTimeForm.changeapply"
                      :label="2"
                      >Yes</el-radio
                    >
                    <el-radio
                      v-model="updateCourseTimeForm.changeapply"
                      :label="3"
                      >No</el-radio
                    >
                    <div v-if="updateCourseTimeForm.changeapply === 3">
                      <div>Reason of rejection:</div>
                      <el-input
                        v-model="updateCourseTimeForm.reject_reason"
                      ></el-input>
                    </div>
                  </div>
                  <div style="margin-top: 20px; text-align: right">
                    <el-button
                      size="small"
                      style="background: #f48c06; color: #fff; border: none"
                      @click="handleConfirmUpdateTime"
                      >Sure</el-button
                    >
                  </div>
                </div>
                <div
                  slot="reference"
                  style="margin-top: 6px; display: inline-block"
                >
                  <el-badge is-dot>
                    <span
                      class="popover-operation"
                      @click="getUpdateCourseTime(item)"
                      >Rescheduling confirm</span
                    >
                  </el-badge>
                </div>
              </el-popover>

              <el-tooltip
                v-else
                effect="light"
                content="Requesting for session rescheduling"
                placement="top"
              >
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>

            <div v-if="item.changeapply === 2">
              <el-tooltip effect="light" content="Rescheduled" placement="top">
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
            <div v-if="item.changeapply === 3">
              <el-tooltip
                effect="light"
                content="Rescheduling failed"
                placement="top"
              >
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>

            <!-- v-if="item.status=== '1'" -->
          </div>
        </div>

        <div v-if="childOrderList.length < 5">
          <div
            class="list-content"
            v-for="index in 5 - childOrderList.length"
            :key="index"
          ></div>
        </div>
      </div>
    </div>
    <KtPag
      v-if="orderInformationVisible"
      style="text-align: right"
      :pageCount="childOrderForm.count"
      :currentPage="childOrderForm.page"
      :limit="childOrderForm.limit"
      @onChange="onChildOrderSizeChange"
    ></KtPag>

    <el-dialog
      custom-class="evaluate-dialog"
      :visible.sync="evaluateDialog"
      :append-to-body="true"
      title="What do you think of"
    >
      <div class="tutor-name">French</div>
      <div class="tutor-star">
        <el-rate
          v-model="commentForm.rate"
          show-score
          score-template="{value}"
        ></el-rate>
      </div>
      <div class="star-info">Five-star praise! Great course, thumbs up!</div>
      <el-input
        type="textarea"
        style="margin-top: 32px"
        v-model="commentForm.content"
        :rows="5"
        placeholder="How is the course, tell me how you feel"
      ></el-input>
      <div class="box-foot">
        <div class="my-button cancel" @click="evaluateDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="handleSubmitEvaluate">SURE</div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="commentInfo.covey_user"
      custom-class="student-reviews-dialog"
      :visible.sync="reviewDialog"
      append-to-body
      title="Course evaluation"
    >
      <div class="comment-card">
        <div class="comment-people">
          <div style="display: flex; align-items: center">
            <div class="circle">
              {{ userInfo.realname ? userInfo.realname[0] : "" }}
            </div>
            <span
              >{{ userInfo.realname ? userInfo.realname[0] : "" }} (Me)</span
            >
          </div>
          <div class="main-title-right">
            <img src="@/assets/icon/star.png" />
            <span>{{ commentInfo.covey_comment.rate }}</span>
          </div>
        </div>
        <div class="comment-content">
          {{ commentInfo.covey_comment.content }}
        </div>
        <div class="comment-time">
          {{ format(commentInfo.covey_comment.comment_time) }}
        </div>
      </div>

      <div class="reply-card" v-if="commentInfo.covey_comment.is_reply === 1">
        <div class="reply-content">
          <div>
            See the response
            {{ commentInfo.covey_user ? commentInfo.covey_user.realname : "" }}
            :
            {{ commentInfo.covey_comment.replied_content }}
          </div>
          <div class="reply-time">
            {{ format(commentInfo.covey_comment.replied_time) }}
          </div>
        </div>
      </div>
      <div class="box-foot">
        <div class="my-button cancel" @click="reviewDialog = false">CANCEL</div>
        <div class="my-button" @click="reviewDialog = false">SURE</div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="changeTimeDialog"
      title="Select the time to modify."
      width="80%"
    >
      <ScheduleTable
        v-if="changeTimeDialog"
        @TempSchedule="onTempScheduleChange"
        :highlightTable="[myClassTable]"
        :classSlot="myClassTable.slot"
        :multiple="false"
      >
      </ScheduleTable>
      <div class="box-foot">
        <div class="my-button cancel" @click="changeTimeDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="handleChangeTime">SURE</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="lessonappealDialog" title="Case" width="60%">
      <el-form :model="lessonappealForm" label-width="200px">
        <!-- <el-form-item label="申述须知:">
          <div>申述须知申述须知申述须知申述须知申述须知申述须知</div>
        </el-form-item> -->
        <el-form-item label="Order number:">
          <div>{{ lessonappealForm.calendar_id }}</div>
        </el-form-item>
        <el-form-item label="Description of issue:">
          <el-input
            type="textarea"
            v-model="lessonappealForm.reason"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="Supporting materials:">
          <el-upload
            ref="my-appeal-upload"
            :before-upload="beforeImgUpload"
            :on-exceed="handleImgExceed"
            :on-error="handleImgUploadError"
            :on-success="handleImgSuccess"
            :action="getUploadImg + '?ts=' + Date.now()"
            multiple
            :limit="3"
            :headers="{ 'x-covey-token': xToken }"
            :accept="imgRules"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="box-foot">
        <el-button class="my-button cancel" @click="lessonappealDialog = false"
          >CANCEL</el-button
        >
        <el-button
          class="my-button"
          @click="handleLessonappeal"
          v-loading="lessonappealLoading"
          >SURE</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="appealResDialog"
      title="Support case result"
      width="80%"
    >
      <el-form :model="appealRes" label-width="200px">
        <el-form-item label="Order number:">
          <div>{{ appealRes.calendarId }}</div>
        </el-form-item>

        <el-form-item label="Description of issue:">
          <el-input
            type="textarea"
            v-model="appealRes.reason"
            :rows="5"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="Supporting materials:">
          <div style="display: flex">
            <div
              style="display: inline-block; margin-right: 12px"
              v-for="(item, index) in appealRes.proofImg"
              :key="index"
            >
              <img style="width: 180px; height: auto" :src="item" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Tutor penalty amount:">
          <div>C$ {{ appealRes.tutorpunishment | formatMoneyNumber }}</div>
        </el-form-item>

        <el-form-item label="Send students coupons:">
          <div>C$ {{ appealRes.sturefund | formatMoneyNumber }}</div>
        </el-form-item>

        <el-form-item label="Status of case:">
          <div>{{ appealStatus[appealRes.status] }}</div>
        </el-form-item>
      </el-form>
      <div class="box-foot">
        <div class="my-button cancel" @click="appealResDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="appealResDialog = false">SURE</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScheduleTable from "@/views/Pc/Component/ScheduleTable";
import { format } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import KtPag from "@/views/Comm/KtPag";
import _ from "lodash";
export default {
  components: {
    ScheduleTable,
    KtPag,
  },
  filters: {
    formatMoneyNumber(value) {
      if (typeof value === "number" && !isNaN(value)) {
        //必要
        return (Number(value) / 100).toFixed(2);
      } else {
        return "-";
      }
    },
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
    }),
    ...mapGetters(["getUploadImg"]),
    showFilterLabels() {
      return (
        this.orderStatusLabelList.length > 0 ||
        this.refundStatusLabelList.length > 0
      );
    },
    showChildFilterLabels() {
      return (
        this.childOrderStatuslabelList.length > 0 ||
        this.commentStatusLabelList.length > 0 ||
        this.complainStatusLabelList.length > 0
      );
    },
  },
  data() {
    return {
      queryStr: "",

      orderlistForm: {
        page: 1,
        limit: 10,
        count: 0,
      },
      purchasedOrderList: [],
      format: format,

      childOrderStatusMap: {
        //子订单
        "-1": { name: "Invalid", icon: "el-icon-remove", color: "#7E8088" },
        0: {
          name: "No appointment",
          icon: "el-icon-loading",
          color: "#f48c06",
        },
        1: { name: "Booked", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Canceled", icon: "el-icon-error", color: "#f56c6c" },
        3: { name: "In class", icon: "el-icon-error", color: "#f56c6c" },
        4: { name: "To be confirmed", icon: "el-icon-error", color: "#f56c6c" },
        5: { name: "Completed", icon: "el-icon-success", color: "#3BB20A" },
      },
      orderStatusMap: {
        //父订单
        1: { name: "To be paid", icon: "el-icon-remove", color: "#7E8088" },
        2: {
          name: "Payment successful",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
        3: { name: "Canceled", icon: "el-icon-error", color: "#f56c6c" },
        4: { name: "Ongoing", icon: "el-icon-circle-check", color: "#f48c06" },
        5: { name: "Completed", icon: "el-icon-success", color: "#3BB20A" },
      },

      refund_status: {
        //退款状态
        0: { name: "Not applied", icon: "", color: "" },
        1: {
          name: "Refund in progress",
          icon: "el-icon-loading",
          color: "#f48c06",
        },
        2: {
          name: "Refund:Tutor agreed",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
        3: {
          name: "Refund:Tutor rejected",
          icon: "el-icon-error",
          color: "#f56c6c",
        },
      },

      commentstatusMap: {
        //子订单的评论状态
        0: { name: "Not evaluated", icon: "", color: "" },
        1: { name: "Evaluated", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Auto", icon: "el-icon-success", color: "#3BB20A" },
      },
      complainstatusMap: {
        0: "No supporting case filed.",
        1: "Supporting case in progress.",
        2: "Supporting case solved.",
        3: "Case failed.",
      },
      appealStatus: {
        1: "In progress",
        2: "Warning tutor",
        3: "Penalty tutor",
        4: "Refund",
      },
      orderInformationVisible: false,
      evaluateDialog: false,
      evaluateStar: 4.5,
      orderDetail: {},
      childOrderList: [], //子订单列表
      commentForm: {
        order_id: "",
        calendar_id: "",
        rate: 5,
        content: "",
      },
      commentInfo: {},
      reviewDialog: false,
      changeTimeDialog: false,
      scheduleData: [],
      myClassTable: [], //点击change time 时修改的课程
      updateCourseTimeForm: {
        //
        targetTime: "", //申请的时间
        new_calendar_id: "",
        id: "",
        changeapply: 2, //2表示同意 3表示拒绝
        reject_reason: "", //拒绝时要填写原因
      },

      //申述
      lessonappealDialog: false,
      lessonappealLoading: false,
      lessonappealForm: {
        //
        calendar_id: "",
        reason: "",
        proofImg: [],
      },

      appealResDialog: false, //申述结果
      appealRes: {},

      imgRules: "image/png , image/jpeg",
      childOrderForm: {
        page: 1,
        limit: 10,
        count: 0,
        type: "1",
      },
      orderStatusList: [
        { name: "To be paid", status: 1 },
        { name: "Paid", status: 2 },
        { name: "Canceled", status: 3 },
        { name: "In progress", status: 4 },
        { name: "Completed", status: 5 },
      ],
      orderStatusLabelList: [],
      orderPopoverShow: false,
      refundStatusList: [
        //退款状态
        { name: "Not applied", status: 0 },
        {
          name: "In progress",
          status: 1,
        },
        {
          name: "Tutor agreed",
          status: 2,
        },
        {
          name: "Tutor rejected",
          status: 3,
        },
      ],
      refundStatusLabelList: [],
      refundPopoverShow: false,
      childOrderStatusList: [
        //子订单
        {
          name: "No appointment",
          status: 0,
        },
        { name: "Booked", status: 1 },
        { name: "Canceled", status: 2 },
        { name: "In class", status: 3 },
        { name: "To be confirmed", status: 4 },
        { name: "Completed", status: 5 },
      ],
      childOrderStatuslabelList: [],
      childOrderPopoverShow: false,
      commentStatusList: [
        //子订单的评论状态
        { name: "Not evaluated", status: 0 },
        { name: "Evaluated", status: 1 },
        { name: "Auto", status: 2 },
      ],
      commentStatusLabelList: [],
      commentStatusPopoverShow: false,
      complainStatusList: [
        //投诉状态
        { name: "No supporting case filed", status: 0 },
        { name: "Supporting case in progress", status: 1 },
        { name: "Supporting case solved", status: 2 },
        { name: "Case failed", status: 3 },
      ],
      complainStatusLabelList: [],
      complainStatusPopoverShow: false,
    };
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
  },
  created() {
    if (this.userInfo.usertype === 1) {
      this.$router.push("/groupInfo/orders");
    }
    this.initPage();
  },
  methods: {
    orderProgressFomat(p, item) {
      return (
        "Total:" +
        item.amounts +
        " Used:" +
        item.used_amounts +
        " Canceled:" +
        item.cancel_amounts
      );
    },
    initPage() {
      if (this.$route.query && this.$route.query.orderId) {
        if (!this.orderDetail.covey_course) {
          this.$router.push({
            path: this.$route.path,
          });
          return;
        }
        this.orderInformationVisible = true;
        this.getChildOrderList(1);
      } else if (this.$route.query && this.$route.query.Id) {
        //如果有id进来 则加参数
        this.orderInformationVisible = false;
        this.orderlistForm.id = this.$route.query.Id;
        this.getPurchasedList(1);
      } else {
        this.orderInformationVisible = false;
        delete this.orderlistForm.id;
        this.getPurchasedList(1);
      }
    },
    checkOrder(item) {
      this.orderDetail = item;
      this.$router.push({
        path: this.$route.path,
        query: {
          orderId: item.id,
        },
      });
    },
    //支付订单
    gotoPay(item) {
      if (item.order_status === 1) {
        this.$router.push({
          path: "/page/bookacourse",
          query: {
            orderId: item.id,
          },
        });
        return;
      } else {
        this.$message.warning("This order has already been paid!");
      }
    },
    onChildOrderSizeChange({ page, limit }) {
      this.childOrderForm.page = page;
      this.childOrderForm.limit = limit;
      this.getChildOrderList(2);
    },
    //课程订单详情页面下的子订单列表
    getChildOrderList(type) {
      if (type === 1) {
        this.childOrderForm.page = 1;
      }
      let params = { ...this.childOrderForm };
      params["orderId"] = this.$route.query.orderId;
      delete params.count;
      if (this.childOrderStatuslabelList.length > 0) {
        params["status"] = this.childOrderStatusList
          .map((item) => {
            for (let label of this.childOrderStatuslabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.commentStatusLabelList.length > 0) {
        params["commentstatus"] = this.commentStatusList
          .map((item) => {
            for (let label of this.commentStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.complainStatusLabelList.length > 0) {
        params["complainstatus"] = this.complainStatusList
          .map((item) => {
            for (let label of this.complainStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      this.childOrderList = [];
      this.$api.courseApi.getOrderLessons(params).then((res) => {
        if (res.status === "0") {
          this.childOrderList = res.data.rows;
          this.childOrderForm.count = res.data.count;
        }
      });
    },
    //to evaluate
    openEvaluateDialog(item) {
      // if (item.covey_comment) return;
      this.commentForm.order_id = item.orderId;
      this.commentForm.calendar_id = item.id;
      this.evaluateDialog = true;
    },
    handleSubmitEvaluate() {
      let params = { ...this.commentForm };

      this.$api.courseApi.addComment(params).then((res) => {
        if (res.status === "0") {
          this.$message.success("Success!");
          this.getChildOrderList();
          this.evaluateDialog = false;
        } else {
          this.$message.error("Error:" + res.message);
        }
      });
    },
    onPurchasedListPageChange({ page, limit }) {
      this.orderlistForm.page = page;
      this.orderlistForm.limit = limit;
      this.getPurchasedList(2);
    },
    getPurchasedList(type) {
      if (type === 1) {
        this.orderlistForm.page = 1;
      }
      let params = { ...this.orderlistForm };
      if (this.orderStatusLabelList.length > 0) {
        params["order_status"] = this.orderStatusList
          .map((item) => {
            for (let label of this.orderStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      if (this.refundStatusLabelList.length > 0) {
        params["refund_status"] = this.refundStatusList
          .map((item) => {
            for (let label of this.refundStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      this.$api.courseApi.getStudentOrders(params).then((res) => {
        if (res.status === "0") {
          this.orderlistForm.count = res.data.count;
          res.data.rows.forEach((item) => {
            item.covey_course.courseImg = JSON.parse(
              item.covey_course.courseImg || "[]"
            );
          });
          this.purchasedOrderList = res.data.rows;
        }
      });
    },

    //学生已经评价，查看评价
    openReviewdialog(item) {
      if (!item.covey_comment) {
        return;
      }
      this.commentInfo = item;
      this.reviewDialog = true;
    },
    // 更改时间
    changeTime(item) {
      this.myClassTable = item;
      this.changeTimeDialog = true;
    },
    //学生确认上课完成
    confirmClass(item) {
      if (item.complainstatus === 1) {
        this.$confirm(
          "The course is in complaint status. If you click OK, the complaint will be withdrawn. Are you sure?",
          "",
          {
            type: "warning",
          }
        )
          .then(() => {
            this.$api.courseApi
              .studentConfirmLession({ id: item.id })
              .then((res) => {
                if (res.status === "0") {
                  this.$message.success(res.message);
                  this.getChildOrderList();
                } else {
                  this.$message.error(res.message);
                }
              });
          })
          .catch((err) => {});
      } else {
        this.$confirm("Are you sure the class is over??", "", {
          type: "warning",
        })
          .then(() => {
            this.$api.courseApi
              .studentConfirmLession({ id: item.id })
              .then((res) => {
                if (res.status === "0") {
                  this.$message.success(res.message);
                  this.getChildOrderList();
                } else {
                  this.$message.error(res.message);
                }
              });
          })
          .catch((err) => {});
      }
    },
    onTempScheduleChange(data) {
      this.scheduleData = data;
    },
    //修改课程时间 提交数据
    handleChangeTime() {
      if (this.scheduleData && this.scheduleData.length > 0) {
        let params = { ...this.scheduleData[0] };
        params.id = this.myClassTable.id;
        this.$api.courseApi.updateCourseTime(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.changeTimeDialog = false;
            this.getChildOrderList(1);
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
      }
    },
    //取消课程
    cancelClass(item) {
      this.$confirm("Are you sure to cancel the order?", "", {
        type: "warning",
      })
        .then(() => {
          this.$api.courseApi.cancelorder({ id: item.id }).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getPurchasedList(1);
            } else {
              this.$message.error("Error!" + res.message);
            }
          });
        })
        .catch((err) => {});
    },
    //申请退款
    withdrawOrder(item) {
      this.$confirm("Are you sure to apply for a refund?", "", {
        type: "warning",
      })
        .then(() => {
          this.$api.orderApi.withdraworder({ id: item.id }).then((res) => {
            if (res.status === "0") {
              this.$message.success(res.message);
              this.getPurchasedList(1);
            } else {
              this.$message.error("Error!" + res.message);
            }
          });
        })
        .catch((err) => {});
    },

    getUpdateCourseTime(item) {
      this.updateCourseTimeForm.id = item.id;
      this.updateCourseTimeForm.new_calendar_id = item.new_calendar_id;
      this.$api.courseApi
        .getUpdateCourseTime({ new_calendar_id: item.new_calendar_id })
        .then((res) => {
          if (res.status === "0") {
            this.updateCourseTimeForm.targetTime =
              res.data.apdate +
              " " +
              res.data.starttime +
              "-" +
              res.data.endtime;
          } else {
            this.$message.error("Error!" + res.message);
          }
        });
    },
    handleConfirmUpdateTime() {
      let params = { ...this.updateCourseTimeForm };
      delete params.targetTime;

      this.$api.courseApi.confirmUpdateCourseTime(params).then((res) => {
        if (res.status === "0") {
          this.$message.success(res.message);
          this.getChildOrderList(1);
        } else {
          this.$message.error("Error!" + res.message);
        }
      });
    },
    //学生申述
    gotoLessonappeal(item) {
      this.lessonappealDialog = true;
      this.lessonappealForm.calendar_id = item.id;
      this.lessonappealForm.reason = "";
      this.$nextTick(() => {
        this.$refs["my-appeal-upload"].clearFiles();
      });
    },

    //查看申述结果
    viewappeal(item) {
      this.appealResDialog = true;
      this.getAppealResult(item.id);
    },
    // 获取申述内容
    getAppealResult(id) {
      this.$api.orderApi.getappeal({ calendarId: id }).then((res) => {
        res.data.proofImg = JSON.parse(res.data.proofImg);

        this.appealRes = res.data;
      });
    },

    // 提交申述结果
    handleLessonappeal() {
      // console.log(this.$refs['my-appeal-upload']);
      this.lessonappealLoading = true;
      let params = _.cloneDeep(this.lessonappealForm);
      for (let item of this.$refs["my-appeal-upload"].uploadFiles) {
        if (item.response && item.response.status === "0") {
          params.proofImg.push(item.response.data);
        } else {
          this.$message.error("Please wait for the picture to upload.");
          this.lessonappealLoading = false;
          return;
        }
      }
      this.$api.courseApi.lessonappeal(params).then((res) => {
        if (res.status === "0") {
          this.lessonappealDialog = false;
          this.getChildOrderList(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.lessonappealLoading = false;
      });
    },
    //***上传图片****/

    //上传文件检查
    beforeImgUpload(file) {
      const isImage = this.imgRules.includes(file.type);
      const isLt20M = file.size / 1024 / 1024 <= 5;
      if (!isImage) {
        this.$message.error(
          "Only upload pictures in PNG/JPG format is supported."
        );
        return isImage && isLt20M;
      }
      if (!isLt20M) {
        this.$message.error("Upload picture size cannot exceed 5MB.");
        return isImage && isLt20M;
      }
      return isImage && isLt20M;
    },
    //文件个数超出限制
    handleImgExceed(files, fileList) {
      this.$message.error("Up to three photos can be uploaded");
    },
    //上传失败
    handleImgUploadError(err, file, fileList) {
      if (err) {
        this.$message.error(`${file.name} ERROR!`);
      }
    },
    //上传成功获取上传图片地址
    async handleImgSuccess(res, file, fileList) {
      if (res.status === "0") {
        // this.basicCourseForm.courseImg = res.data;
      } else {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
    },

    contactPeople(id) {
      if (!this.xToken) {
        this.$store.commit("SET_LOGIN_DIALOG", true); //关闭登录dialog
        return;
      }
      if (id === this.userInfo.id) {
        this.$message.error("Can't talk to yourself!");
        return;
      }
      let routeData = this.$router.resolve({
        path: "/chat?contactId=" + id,
      });
      window.open(routeData.href, "_blank");
    },
    goBack() {
      window.history.back();
    },
    clearFilterLabel(type) {
      if (type === 1) {
        this.orderStatusLabelList = [];
      } else if (type === 2) {
        this.refundStatusLabelList = [];
      } else if (type === 3) {
        this.childOrderStatuslabelList = [];
      } else if (type === 4) {
        this.commentStatusLabelList = [];
      } else if (type === 5) {
        this.complainStatusLabelList = [];
      }
    },
    applyFilter(type) {
      if (type === 1) {
        this.getPurchasedList(1);
        this.orderPopoverShow = false;
      } else if (type === 2) {
        this.getPurchasedList(1);
        this.refundPopoverShow = false;
      } else if (type === 3) {
        this.getChildOrderList(1);
        this.childOrderPopoverShow = false;
      } else if (type === 4) {
        this.getChildOrderList(1);
        this.commentStatusPopoverShow = false;
      } else if (type === 5) {
        this.getChildOrderList(1);
        this.complainStatusPopoverShow = false;
      }
    },
    resetFilter(type) {
      if (type === 1) {
        this.orderStatusLabelList = [];
        this.refundStatusLabelList = [];
        this.getPurchasedList(1);
      } else if (type === 2) {
        this.childOrderStatuslabelList = [];
        this.commentStatusLabelList = [];
        this.complainStatusLabelList = [];
        this.getChildOrderList(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.order-purchased-box {
  width: 100%;
  height: 100%;
  // box-sizing: border-box;
  padding: 24px 32px;
  .search-box {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    padding: 12px 24px;
    margin-bottom: 24px;
    box-sizing: border-box;
    .search-box-fliter-box {
      display: flex;
      justify-content: space-between;
      .search-box-fliter {
        display: flex;
      }
      .search-box-reset-box {
        .reset-bt {
          font-size: 14px;
        }
      }
    }
    .select-filter {
      color: #f48c06 !important;
      border-color: #f8d19e !important;
      background-color: #ffffff !important;
    }
    .filter-btn-box {
      font-weight: 600;
      color: #7e8088;
      min-width: 50px;
      padding: 6px 12px;
      border-radius: 4px;
      border: 1px solid #dadbdd;
      margin-right: 12px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
      .arrow-box {
        margin-left: 6px;
        i {
          transition: all 500ms;
          font-size: 12px;
          &:hover {
            color: #f48c06;
            border-color: #f8d19e;
            background-color: #ffffff;
          }
        }
      }
      .submenu-icon-arrow {
        transform: rotate(180deg);
      }
    }
    .reset-bt {
      font-size: 14px;
      color: #7e8088;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
    }
  }
  .search-box-li {
    // height: 35px;
    // padding: 6px 0;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    .filters-wrapper {
      color: #7e8088;
      font-size: 14px;
      // line-height: 22px;
      font-weight: 600;
      background-color: #efeff0;
      margin: 0 10px 10px 0;
      padding: 3px 12px;
      // border: none;
      border-radius: 50px;
      box-sizing: border-box;
    }
  }
  .flex {
    padding: 0 6px;
    align-self: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .flex_1,
  .flex_2,
  .flex_3,
  .flex_4,
  .flex_5,
  .flex_6,
  .flex_7,
  .flex_8,
  .flex_9,
  .flex_10 {
    padding: 0 6px;
    align-self: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .flex_1 {
    flex: 1;
  }
  .flex_2 {
    flex: 2;
  }
  .flex_3 {
    flex: 3;
  }
  .flex_4 {
    flex: 4;
  }
  .flex_5 {
    flex: 5;
  }
  .flex_6 {
    flex: 6;
  }
  .flex_7 {
    flex: 7;
  }
  .flex_8 {
    flex: 8;
  }
  .flex_9 {
    flex: 9;
  }
  .flex_10 {
    flex: 10;
  }
  .goback {
    color: #f48c06;
  }
  .operation {
    color: #f48c06;
    span {
      padding: 2px;
      color: #f48c06;
      cursor: pointer;
    }
  }
  /deep/.el-progress-bar__inner {
    text-align: left;
  }
  .popover-operation {
    padding: 2px;
    color: #f48c06;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .operation_events {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    height: 100%;
    span {
      padding: 2px 4px;
      color: #f48c06;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .info-box {
    height: 100%;
  }
  .info-img {
    width: 100px;
    height: 76px;
    display: inline-block;
    border: 0.5px solid #dbd9d6;
    vertical-align: top;
  }
  .price-info-detail {
    width: 80%;
    display: inline-block;
    color: #201002;
    vertical-align: top;

    .detail-content {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 3px 0;
      display: flex;
      justify-content: space-between;
      &:hover {
        background: #f0f0f0;
      }
    }
  }

  .chat-icon {
    font-size: 18px;
    cursor: pointer;
    color: #f48c06;
  }

  .info-detail {
    width: 58%;
    display: inline-block;
    color: #201002;
    vertical-align: top;
    .detail-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // white-space: break-spaces;
    }
    .detail-content {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      justify-content: space-between;
    }
    .detail-time {
      font-size: 14px;
      color: #b7b2ae;
      line-height: 20px;
      margin-top: 6px;
    }
    .id_time {
      color: #b7b2ae;
      div {
        line-height: 16px;
      }
    }
  }

  .myinfo-com-pur-content {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    .list-head,
    .list-content {
      display: flex;
      padding: 12px 24px;
      box-sizing: border-box;
    }
    .list-head {
      height: 72px;
      font-size: 18px;
      color: #201002;
    }
    .list-content {
      min-height: 112px;
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .operation {
        span {
          color: #f48c06;
          cursor: pointer;
        }
      }
    }
    .info {
      flex: 6;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      img {
        width: 136px !important;
        height: 100%;
        border-radius: 16px;
      }
    }
  }

  .order-information {
    .search-box {
      margin: 24px 0 !important;
    }
    .item-title {
      height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #201002;
      line-height: 30px;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
    }
    .item-content {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      .item-content-left {
        display: flex;
        img {
          width: 200px;
          height: 146px;
          border-radius: 8px;
        }
        .order-info {
          margin-left: 24px;
          div:nth-child(1) {
            height: 24px;
            font-size: 18px;
            font-weight: 500;
            color: #201002;
            line-height: 24px;
          }
          div:nth-child(2) {
            font-size: 14px;
            margin-top: 16px;
          }
          div:nth-child(n + 3) {
            font-size: 14px;
            margin-top: 8px;
          }
        }
      }
      .item-content-right {
        text-align: right;
        div:nth-child(1) {
          height: 24px;
          font-size: 24px;
          font-weight: 600;
          color: #f48c06;
          line-height: 24px;
          margin-bottom: 76px;
        }
        div:nth-child(n + 2) {
          font-size: 14px;
        }
      }
    }

    .order-course-list {
      margin-top: vw(32);
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      background: #ffffff;
      .list-head,
      .list-content {
        display: flex;
        padding: 0 vw(32);
        box-sizing: border-box;
      }
      .list-head {
        min-height: 72px;
        height: 72px;
        font-size: 18px;
        color: #201002;
      }
      .list-content {
        height: 72px;
        border-top: 1px solid #dbd9d6;
        font-size: 14px;
        .operation {
          span {
            color: #f48c06;
            cursor: pointer;
          }
        }
      }
    }
  }
  .price-item {
    display: flex;
    &:hover {
      background: #f0f0f0;
    }
  }
  .price-t {
    width: 56px;
  }

  .price-v {
    // width: 60px;
  }
  .oprate-icon {
    cursor: pointer;
    color: #f48c06;
  }
}
.evaluate-dialog {
  border-radius: 8px;
  .el-dialog__header {
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .tutor-name {
    height: 30px;
    font-size: 18px;
    font-weight: 600;
    color: #201002;
    line-height: 30px;
    text-align: center;
  }
  .tutor-star {
    margin-top: 32px;
    text-align: center;
    i {
      color: rgba(244, 140, 6, 1);
      font-size: 24px;
    }
  }
  .star-info {
    text-align: center;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #201002;
    line-height: 25px;
    margin-top: 16px;
  }
  .el-dialog__body {
    padding: 0 56px 46px;
    box-sizing: border-box;
    .box-foot {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      font-size: 14px;
    }
  }
}
.student-reviews-dialog {
  border-radius: 8px;
  .el-dialog__header {
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .el-dialog__body {
    padding: 0 56px 46px;
    box-sizing: border-box;

    .comment-card {
      margin-top: 16px;
      padding: 16px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;

      .comment-people {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .circle {
          width: 32px;
          height: 32px;
          background: #fecb3e;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .comment-content {
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #201002;
        line-height: 30px;
        margin-top: 16px;
      }
      .comment-time {
        text-align: right;
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #b7b2ae;
        line-height: 30px;
        margin-top: 16px;
      }
      .main-title-right {
        padding: 6px 16px;
        border-radius: 24px;
        background: rgba(252, 233, 209, 0.54);
        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .reply-card {
      width: 100%;
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
      .reply-content {
        width: 520px;
        background: #e4e4e4;
        padding: 16px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        line-height: 30px;
        color: #201002;
        font-weight: 600;
      }
      .reply-time {
        text-align: right;
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #b7b2ae;
        line-height: 30px;
        margin-top: 16px;
      }
    }

    .box-foot {
      margin-top: 56px;
      display: flex;
      justify-content: center;
      font-size: 14px;
    }
  }
}

.box-foot {
  margin-top: 56px;
  display: flex;
  justify-content: center;
  font-size: 14px;

  .my-button {
    cursor: pointer;
    width: 120px;
    height: 48px;
    background: #f48c06;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border: none;
    span {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .cancel {
    margin-right: 24px;
    background: #f2f2f2;
    color: #201002;
  }
  .el-textarea__inner {
    font-family: "PingFangSC-Semibold", "PingFang SC";
    border-radius: 8px;
  }
}
</style>
